import { ProductImageWithFallbacks } from "./ProductImageWithFallbacks";
import { normalizeGiftLidLayout, normalizeGiftLidTextColor } from "./GiftBoxLidEditor";

/**
 * Read-only gift box lid preview — message positioned on the product photo.
 */
export default function GiftBoxLidPreview({
  imageUrls = [],
  message = "",
  layout,
  textColor = "gold",
  className = "",
}) {
  const { position, xPct, yPct, anchorX, anchorY, scale } = normalizeGiftLidLayout(layout);
  const lidTextColor = normalizeGiftLidTextColor(textColor);
  const displayText = String(message || "").trim() || "—";
  const hasPhoto = Array.isArray(imageUrls) && imageUrls.some(Boolean);

  return (
    <div className={`gift-lid-board gift-lid-board--preview ${className}`.trim()}>
      <div
        className={`gift-lid-board__frame${hasPhoto ? "" : " gift-lid-board__frame--fallback"}`}
        role="img"
        aria-label={`Gift box preview: ${displayText}`}
      >
        {hasPhoto ? (
          <ProductImageWithFallbacks
            urls={imageUrls}
            alt=""
            className="gift-lid-board__photo"
            loading="lazy"
          />
        ) : null}

        <div className="gift-lid-board__veil" aria-hidden />

        <div
          className={`gift-lid-board__caption-shell gift-lid-board__caption-shell--${position}`}
          style={{
            left: `${xPct}%`,
            top: `${yPct}%`,
            transform: `translate(${anchorX}%, ${anchorY}%) scale(${scale})`,
          }}
          aria-hidden
        >
          <p className={`gift-lid-board__caption gift-lid-board__caption--${lidTextColor}`}>
            {displayText}
          </p>
        </div>
      </div>
    </div>
  );
}
